
    import { computed, ref, onMounted, onUnmounted } from 'vue';
    import { loadingController, IonPage, IonTabs, IonRouterOutlet, IonTabBar, IonTabButton, IonLabel, IonIcon, IonTitle, IonToolbar, IonHeader, IonMenuButton, IonButtons } from '@ionic/vue';
    import { homeOutline, walletOutline, peopleCircleOutline, logoWhatsapp, logOutOutline, accessibilityOutline } from 'ionicons/icons';
    import SidebarMenu from '@/components/SidebarMenu.vue'
    import GalidanciaHomeLogo from '@/components/GalidanciaHomeLogo.vue'
    import userAuth from '@/composables/userAuth';
import { UserServices } from '@/services/UserServices';
import { currentUserStore } from '@/stores/currentUser';
import tools from "@/composables/tools";
import { setPendingNavigationVisit } from '@/composables/navigationVisits';
import { useFixedBannerHeight } from '@/composables/useFixedBannerHeight';
import { useRoute } from 'vue-router';


    export default {
      components: { SidebarMenu, GalidanciaHomeLogo, IonPage, IonTabs, IonRouterOutlet, IonTabBar, IonTabButton, IonLabel, IonIcon, IonTitle, IonToolbar, IonHeader, IonMenuButton, IonButtons },
      setup() {
        const route = useRoute();
        const tabBarRef = ref<HTMLElement | null>(null);
        const mostrarBotonWhatsappAyuda = ref(false);
        let timeoutAyuda: ReturnType<typeof setTimeout> | null = null;

        onMounted(() => {
          timeoutAyuda = setTimeout(() => {
            mostrarBotonWhatsappAyuda.value = true;
          }, 120000);
        });
        onUnmounted(() => {
          if (timeoutAyuda) clearTimeout(timeoutAyuda);
        });

        const estaAutenticado = computed(() => {
          const u = currentUserStore().$state.user;
          return u != null && (u.id > 0 || !!u.email);
        });

        const isFocusedClaseView = computed(() => {
          const path = route.path || '';
          return /^\/tabs\/clases\/\d+$/.test(path);
        });

        const showTabsNavigation = computed(() => !isFocusedClaseView.value);

        /** En el carrito el pie lo ocupa el resumen de la compra, no los tabs. */
        const isCartView = computed(() => (route.path || '').startsWith('/tabs/cart'));

        const showTabBar = computed(() => showTabsNavigation.value && !isCartView.value);

        useFixedBannerHeight(
          tabBarRef,
          '--galidancia-tab-bar-height',
          () => estaAutenticado.value && showTabBar.value,
        );

        const isMensajesChatView = computed(() => {
          const path = route.path || '';
          return /^\/tabs\/mensajes\/chat\/\d+$/.test(path);
        });

        const onTabClases = async () => {
          setPendingNavigationVisit('tab-clases');
          tools().setLog('Pulsaron tab para ver clases')
          tools().showLoading('Cargando mis clases...')
          await UserServices.loadClases()
          loadingController.dismiss()
        }

        const onTabSaldo = () => {
          setPendingNavigationVisit('tab-saldo');
          tools().setLog('Pulsaron tab para ver pagos')
        }

        const onTabAsistencias = () => {
          setPendingNavigationVisit('tab-asistencias');
          tools().setLog('Pulsaron tab para ver asistencias')
        }

        const abrirWhatsappAyuda = () => {
          const phone = (process.env.VUE_APP_WHATSAPP_HELP || '').replace(/\D/g, '') || '34604048881'
          const text = encodeURIComponent('Tengo problemas con la aplicación. ¿Puedes ayudarme?')
          const url = `https://wa.me/${phone}?text=${text}`
          const opened = window.open(url, '_blank')
          if (!opened) window.location.href = url
        }

        return {
          tabBarRef,
          mostrarBotonWhatsappAyuda,
          estaAutenticado,
          showTabsNavigation,
          showTabBar,
          isMensajesChatView,
          onTabClases,
          onTabAsistencias,
          onTabSaldo,
          abrirWhatsappAyuda,
          walletOutline,
          peopleCircleOutline,
          homeOutline,
          userAuth,
          logoWhatsapp,
          currentUserStore,
          logOutOutline,
          accessibilityOutline
        };       
      },
    };
  